<!--
 * @Author: zhongtao
 * @LastEditors: zhongtao
-->
<template>
    <div class="dialog-container">
        <el-dialog
        title="补扣天数"
        :visible.sync="showFlag"
        :before-close="closeDialog"
        center
        :close-on-click-modal="false"
        :append-to-body="true"
        width="500px"
        >
            <el-form :model="form" :rules="rules" label-width="110PX" ref="form">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="会员卡名称" prop="cardName">
                            {{form.cardName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="有效天数" prop="termDays">
                            {{form.termDays || 0}}天
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="现有赠送天数" prop="giveDayQty">
                            {{form.giveDayQty || 0}}天
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="剩余天数" prop="availableDayQty">
                            {{form.availableDayQty + form.giveDayQty}}天
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="补扣天数" prop="deductDay">
                            <el-input-number v-model="form.deductDay" :min="1" :step="1" :precision="0" :max="999999999"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="补扣原因" prop="remark">
                            <el-input v-model="form.remark" type="textarea" :rows="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template slot="footer">
                <el-button class="footer-confirm" @click="sure">确定</el-button>
                <el-button class="footer-cancel" @click="closeDialog">{{$t('cancel')}}</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import apis from "@/apis";
import { mapState } from "vuex";
import { debounce } from "lodash";

export default {
    data() {
        return {
            tableData: [],
            form: {
                deductDay: '',
                remark: '',
            },
            showFlag: false,
            rules: {
                deductDay: { required: true, message: '请输入补扣次数', trigger: 'blur' },
                remark: { required: true, message: '请输入补扣原因', trigger: 'blur' },
            },
        };
    },
    computed: {
        ...mapState(['NAME', 'USERNAME', "serviceMemberInfo", "merchantAccountDetailInfoDTO"]),
    },
    methods: {
        showDialog(data) {
            console.log(data)
            this.form = { ...data, ...this.form }
            this.showFlag = true
        },
        sure: debounce(function () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const formData = {}
                    formData.cardId = this.form.id
                    formData.deductDay = this.form.deductDay
                    formData.remark = this.form.remark
                    formData.userId = this.form.userId
                    formData.operatorName = this.NAME
                    formData.operatorPhone = this.USERNAME
                    this.$http.post(apis.userCardDeductDay, formData).then((res) => {
                        if (res.data.code === 0) {
                            this.$message.success('操作成功')
                            this.closeDialog()
                            this.$emit('refresh')
                        }
                    })
                }
            })
        }, 500),
        closeDialog() {
            this.showFlag = false
            this.$refs.form.resetFields()
            this.form = {
                deductDay: '',
                remark: '',
            }
        },
    },
}
</script>
<style lang='scss' scoped>
.pageination-wrapper{ padding: 15px 0;}
</style>
